import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../Managers/ProcessManager';
import { Redirect } from "react-router-dom";

class ModalDefecto extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRoute: false
        };
    }

    routeTo() {
        this.setState({ isRoute: true })
    }

    render() {
        const { id, titulo, mensaje, routeDesde, routeHasta } = this.props;
        const { isRoute } = this.state;
        let autoFoco = this.props.autoFoco == true;

        if (isRoute)
            return <Redirect to={ProcessManager.GetNextStep(routeDesde, routeHasta)} push />

        return (
            <div className="modal fade-out" id={id} role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog">
                    <div className="modal-content modal-wide">
                        <div className="modal-header-new">
                            <div className="closeNew" data-dismiss="modal" aria-hidden="true"><label className="ti-close clickable"></label></div>
                            <h2 className="modal-title-new" id="myModalLabel">{titulo}</h2>
                        </div>
                        <div className="modal-body-new">{mensaje}</div>

                        <div className="modal-footer footer-alta-individuo">
                            {!this.props.soloAceptar &&<button data-dismiss="modal" className="btn btn-secondary float-right button-separation-foot" data-toggle="modal" data-target="#cancelar" text="DATOS INCORRECTOS">
                                Cancelar
                            </button >}
                            <button autoFocus={autoFoco} data-dismiss="modal" className="btn btn-cta float-right" onClick={() => this.routeTo()}>
                               Aceptar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalDefecto;